import apiMiddleware from "../api/apiMiddleware";

// Get package analytics
export const getPackageAnalytics = async (fromDate, toDate) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) {
      params.append('from_date', fromDate);
    }
    if (toDate) {
      params.append('to_date', toDate);
    }
    const response = await apiMiddleware.get(`/dashboard/package-analytics?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/** Cross-module summary: periods, revenue, bookings, listing approval status */
export const getDashboardSummary = async () => {
  const response = await apiMiddleware.get("/dashboard/summary");
  return response.data?.data ?? null;
};

